import React from "react";

export default function Badge({ children, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-100 border border-black/10 text-[#64748b] dark:bg-white/[0.05] dark:border-white/[0.08] dark:text-[#6b7a9a]",
    green: "bg-emerald-50 border border-emerald-200 text-emerald-800 dark:bg-green-500/10 dark:border-green-500/20 dark:text-green-400",
    orange: "bg-amber-50 border border-amber-200 text-amber-800 dark:bg-amber-500/10 dark:border-amber-500/20 dark:text-amber-400",
    rose: "bg-rose-50 border border-rose-200 text-rose-800 dark:bg-red-500/10 dark:border-red-500/20 dark:text-red-400",
    amber: "bg-amber-50 border border-amber-200 text-amber-800 dark:bg-amber-500/10 dark:border-amber-500/20 dark:text-amber-400",
    blue: "bg-sky-50 border border-sky-200 text-sky-800 dark:bg-blue-500/10 dark:border-blue-500/20 dark:text-[#7aaeff]",
  };

  return (
    <span
      className={`px-2.5 py-1 rounded-full text-[10px] font-bold ${
        tones[tone] || tones.slate
      }`}
    >
      {children}
    </span>
  );
}
